import css from './BannerWrapper.module.scss';

export default function BannerWrapper({children}) {
  return (
    <div className={css.bannerImagesWrapper}>
      {children}
    </div>
  );
}